import { Component } from '@angular/core';

@Component({
  selector: 'app-totem-info',
  templateUrl: './totem-info.component.html',
  styleUrls: ['./totem-info.component.scss']
})
export class TotemInfoComponent {

}
